import { Dropdown } from '@pm/ui';

export type LocaleCode = 'ca' | 'us' | 'us-es';

export type LocaleSelectorProps = {
  value: LocaleCode;
  onChange: (value: LocaleCode) => void;
};

const LOCALE_OPTIONS = [
  { code: 'ca' as LocaleCode, name: 'Canada (English)', flag: '🇨🇦' },
  { code: 'us' as LocaleCode, name: 'US (English)', flag: '🇺🇸' },
  { code: 'us-es' as LocaleCode, name: 'EEUU (Español)', flag: '🇺🇸' },
];

export const LocaleSelector = ({ value, onChange }: LocaleSelectorProps) => (
  <Dropdown.Root
    value={value}
    ariaLabel="country"
    variant="chip"
    onChange={(v) => onChange(v as LocaleCode)}
  >
    {LOCALE_OPTIONS.map(({ code, name, flag }) => (
      <Dropdown.Item
        key={code}
        value={code}
        text={`${flag} ${name}`}
        ariaLabel={name}
      />
    ))}
  </Dropdown.Root>
);
